module.exports = __webpack_public_path__ + "static/media/ImporterFeatureIcon6.34447cc7.svg";